import store from '@/store';
import { DataProvider } from './DataProvider';

export default async function memoGameA(quiz, { stepGroupId, stepId, lstore = store, activityName = 'memorize' }) {
    const stepGroup = lstore.state.moduleCourse.stepGroups[stepGroupId];
    const quizItems = [];
    const stepIds = stepId ? [stepId] : stepGroup.stepIds;

    stepIds
        .map(stepId => lstore.state.moduleCourse.steps[stepId])
        .forEach(step => {
            const memoIds = step[activityName].memoIds;
            memoIds
                .map(memoId => lstore.state.moduleCourse.memos[memoId])
                .forEach(memo => {
                    const items = [];
                    const text = memo.fact.text;
                    const mnemonics = memo.fantasies[0].mnemonics;
                    mnemonics.forEach(mnemonic => {
                        const ref = mnemonic.factRefs[0];
                        const textFrag = text.substr(ref.offset, ref.length);

                        items.push({
                            target: textFrag,
                            image: mnemonic.imageUrl || mnemonic.numbershape
                        });
                    });

                    quizItems.push({
                        type: 'fallingMatch',
                        // question: 'Match the highlighted words from the step summaries with the right memory images.',
                        question: 'Match nøkkelordene fra sammendraget med huskebildene',
                        items
                    });
                });
        });

    return new DataProvider(quizItems);
}
